<!--
 * @Autor: GeekMzy
 * @Date: 2022-04-18 10:12:47
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-07-18 14:28:44
 * @FilePath: \htwlgs-drainage-webv2-shiju\src\App.vue
 * @Author: desktop-1llkr2o
-->
<script lang="ts" setup>
import { ref } from 'vue'
import { useMainStore } from '@/store/main'
import pinia from '@/store/index'
import Main from '@/views/Main.vue'

const showTile = ref(false)
const mainStore = useMainStore(pinia)
//  -------------------------配置UI库主题
import { NConfigProvider, darkTheme } from 'naive-ui'
import { zhCN, dateZhCN } from 'naive-ui'
</script>

<template>
  <n-config-provider :theme="darkTheme" :locale="zhCN" :date-locale="dateZhCN">
    <n-message-provider>
      <RouterView></RouterView>
      <!-- <Main></Main> -->
    </n-message-provider>
  </n-config-provider>
</template>
<style lang="scss" scoped>
body {
  padding: 0;
  margin: 0;
}

#app {
  width: 100%;
  height: 100%;
  text-align: center;
  color: #fff !important;
  position: relative;
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

</style>
